// Your web app's Firebase configuration

const fbConfig = {
   apiKey: process.env.VUE_APP_FB_API_KEY,
   authDomain: "compliance-admin-b7fbc.firebaseapp.com",
   databaseURL: "https://compliance-admin-b7fbc.firebaseio.com",
   projectId: process.env.VUE_APP_FB_PROJECT_ID,
   storageBucket: "compliance-admin-b7fbc.appspot.com",
   messagingSenderId: "163767469158",
   appId: "1:163767469158:web:a017a540274ce10a1019a7"
};
export default fbConfig;